// Library Imports
import React, { useState } from 'react'
import { Container, Nav, Navbar, Offcanvas, Button, Row, Col, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import * as AiIcons from 'react-icons/ai'
import * as BsIcons from 'react-icons/bs'
import * as BiIcons from 'react-icons/bi'
import * as HiIcons from 'react-icons/hi'
import * as FaIcons from 'react-icons/fa'
// Asset Imports
import '../../assets/css/stylesheets/Navigation.css'
import '../../assets/css/animations/Background.css'
import FullLogo from '../../assets/images/FullLogo.png'
import USJersyLogo from '../../assets/images/USJersey-logo-stroked-RGB_transparent.png'
import ConfigData from '../../config.json'
import { useAuth } from '../../hooks/AuthProvider'

function Navigation() {
    const [show, setShow] = useState(false);

    const showSidebar = () => setShow(true);
    const hideSidebar = () => setShow(false);

    const auth = useAuth();

    return (
        <>
            <Navbar className='navigation-navbar' expand="lg">
                <Container fluid className='navigation-container'>
                    <Navbar.Brand className='navigation-navbar-logo hover-red' href='/'>
                        Jersey Directory
                        <Image src={FullLogo} height='50' />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls='basic-navbar-nav' />
                    <Navbar.Collapse id='basic-navbar-nav'>
                        <Nav className='navigation-navbar-nav-center'>
                            <Link className='nav-link hover-red' to="/">Home</Link>
                            <Link className='nav-link hover-red' to="/listings">Listings</Link>
                            <Link className='nav-link hover-red' to="/pricing">Pricing</Link>
                            <Link className='nav-link hover-red' to="/about">About</Link>
                            <Link className='nav-link hover-red' to="/contact">Contact Us</Link>
                            {
                                auth.user !== null ?
                                    <Link className='nav-link hover-red' to="/employeedirectoryupdates">Directory Updates</Link> :
                                    <></>
                            }
                        </Nav>
                        <Nav className='navigation-navbar-logo'>
                            {
                                auth.user !== null ?
                                    <div>
                                        {auth.user} is Logged in
                                    </div> :
                                    <></>
                            }
                        </Nav>
                        <Navbar.Brand className='navigation-navbar-nav-right'>
                            <Image src={USJersyLogo} height='50' />
                        </Navbar.Brand>
                        <Nav className='navigation-navbar-nav-right'>
                            <HiIcons.HiMenu className='navigation-navbar-nav-right-menu-icon' onClick={showSidebar} />
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Offcanvas className='bg-black text-gray' placement='end' show={show} onHide={hideSidebar}>
                <Offcanvas.Header>
                    <div className='navigation-offcanvas-header'>
                        <div className='navigation-offcanvas-header-close-label'>Close</div>
                        <Button className='navigation-offcanvas-header-close-button' onClick={hideSidebar}>
                            <AiIcons.AiOutlineClose className='navigation-offcanvas-header-close-icon' />
                        </Button>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className='navigation-offcanvas-contact-container'>
                        <div className='navigation-offcanvas-contact-logo'>
                            <h2>Jersey Directory</h2>
                        </div>
                        <div className='navigation-offcanvas-seperator'></div>
                        <div className='navigation-offcanvas-contact-info'>
                            <div className='navigation-offcanvas-contact-header'>Contact Information</div>
                            <div className='navigation-offcanvas-contact-address'>
                                {ConfigData.COMPANY_NAME},
                                <br />
                                {ConfigData.COMPANY_ADDRESS}
                                <br />
                                {ConfigData.COMPANY_CITY}, {ConfigData.COMPANY_STATE} {ConfigData.COMPANY_ZIP_CODE}
                                <br />
                            </div>
                            <div className='navigation-offcanvas-contact-phone'>
                                {ConfigData.COMPANY_PHONE}
                            </div>
                            <a className='navigation-offcanvas-contact-map hover-red' href='https://www.google.com/maps/place/American+Jersey+Cattle+Association/@39.956833,-82.8265039,16z/data=!3m1!4b1!4m6!3m5!1s0x8838637c53a8a651:0xcdf4169d5da88da5!8m2!3d39.956833!4d-82.823929!16s%2Fg%2F11b5z_mk7d?entry=ttu&g_ep=EgoyMDI1MDMwMy4wIKXMDSoASAFQAw%3D%3D'>
                                View Map
                            </a>
                        </div>
                        <div className='navigation-offcanvas-seperator'></div>
                        <div className='navigation-offcanvas-social-container'>
                            <div className='navigation-offcanvas-social'>
                                <a className='navigation-offcanvas-social-facebook' href={ConfigData.FACEBOOK_LINK} target='blank' rel='noopener'>
                                    <FaIcons.FaFacebookF />
                                </a>
                                <a className='navigation-offcanvas-social-instagram' href={ConfigData.INSTAGRAM_LINK} target='blank' rel='noopener'>
                                    <FaIcons.FaInstagram />
                                </a>
                                <a className='navigation-offcanvas-social-youtube' href={ConfigData.YOUTUBE_LINK} target='blank' rel='noopener'>
                                    <FaIcons.FaYoutube />
                                </a>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Navigation